import { Auth } from '@/services/AuthService';
import { IonPage } from '@ionic/vue';
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'EndRedirect',
    created() {
        Auth.Instance.endSessionCallback();
    },
    components: {
        IonPage
    }
});
